import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Label,
  Tooltip,
  Legend,
} from 'recharts';
import { BokbiPieChartProps } from '../BokbiStatistics';
import { aggregateDataByPeriod } from '../../../../util/util';

const colors = ['#3B82F6', '#EF4444'];

interface ExtendedBokbiPieChartProps extends BokbiPieChartProps {
  period?: 'week' | 'month' | '90days' | 'year';
}

const BokbiPieChart: React.FC<ExtendedBokbiPieChartProps> = ({
  annualRawData,
  title,
  period,
}) => {
  const data = aggregateDataByPeriod(annualRawData, title);
  
  // 커스텀 툴팁
  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      return (
        <div className="!bg-white !p-3 !rounded-lg !shadow-lg !border !border-gray-200">
          {payload.map((entry: any, index: number) => (
            <p key={index} className="!text-sm !flex !items-center !gap-2">
              <span 
                className="!w-3 !h-3 !rounded-full" 
                style={{ backgroundColor: entry.color }}
              />
              <span className="!font-medium">{entry.name}:</span>
              <span>{entry.value.toLocaleString()}원</span>
            </p>
          ))}
        </div>
      );
    }
    return null;
  };
  
  // 총합 계산
  const total = data.reduce((sum, entry) => sum + entry.value, 0);
  
  // 비율 계산
  const renderLabel = (entry: any) => {
    const percent = ((entry.value / total) * 100).toFixed(1);
    return `${percent}%`;
  };
  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="45%"
          innerRadius={60}
          outerRadius={90}
          paddingAngle={5}
          dataKey="value"
          label={renderLabel}
          labelLine={false}
        >
          {data.map((entry: any, index: any) => (
            <Cell
              key={`cell-${index}`}
              fill={colors[index % colors.length]}
              style={{ filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))' }}
            />
          ))}
        </Pie>
        <Tooltip content={<CustomTooltip />} />
        <Legend 
          verticalAlign="bottom" 
          height={36}
          iconType="circle"
          formatter={(value) => (
            <span className="!text-sm !font-medium !text-gray-700">{value}</span>
          )}
        />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default BokbiPieChart;
